import { UserFormGlobalErrorMessage } from '../_props'
import { useUserFormErrorContext } from './userFormErrorContext'

const useUserFormGlobalError = () => {
    const { update, state } = useUserFormErrorContext()

    const setGlobaleErrorMessage = (errorMessage: UserFormGlobalErrorMessage) => {
        update({
            globalErrorMessage: errorMessage,
        })
    }

    const clearGlobaleErrorMessage = () => {
        update({
            globalErrorMessage: undefined,
        })
    }

    return {
        setGlobaleErrorMessage,
        clearGlobaleErrorMessage,
        globalErrorMessage: state.globalErrorMessage,
    }
}

export default useUserFormGlobalError
